function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import VentanaSimple from '../../ventana-simple';
import Botonera from '../../ventana-simple/botonera';
import ContenidoVentana from '../../contenido-ventana/contenido-ventana';
import * as Util from '../../util';
var ks = [8, 16, 17, 18, 46];

var Ventana = function (_React$Component) {
  _inherits(Ventana, _React$Component);

  function Ventana(props) {
    _classCallCheck(this, Ventana);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleKeydown = function (e) {
      var keys = _this.state.keys;
      var ksIndex = ks.findIndex(function (value) {
        return value === e.keyCode;
      });

      if (ksIndex > -1) {
        _this.setState({
          keys: keys.map(function (value, index) {
            return index === ksIndex ? true : value;
          })
        }, function () {
          if (_this.state.keys.every(function (value) {
            return value;
          })) {
            Util.removeStorageData('mua');

            _this.props.onCerrar();
          }
        });
      } else {
        _this.setState({
          keys: keys.map(function () {
            return false;
          })
        });
      }
    };

    _this.handleKeyup = function (e) {
      var keys = _this.state.keys;

      _this.setState({
        keys: keys.map(function () {
          return false;
        })
      });
    };

    _this.state = {
      keys: [false, false, false, false, false]
    };
    return _this;
  }

  Ventana.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('keyup', this.handleKeyup);
  };

  Ventana.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.handlekeydown);
    window.removeEventListener('keyup', this.handlekeyup);
  };

  Ventana.prototype.render = function render() {
    var _props = this.props,
        caducado = _props.caducado,
        msg = _props.msg,
        onCerrar = _props.onCerrar;

    if (!caducado && !msg) {
      return null;
    }

    return React.createElement('div', {
      className: 'contenedor ventanaCaducidad',
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backgroundImage: 'initial',
        zIndex: 10000
      }
    }, React.createElement(VentanaSimple, {
      tieneAnimacion: true,
      escalable: false,
      abierta: true,
      flotante: true,
      ancho: 50,
      alto: 33,
      x: 25,
      y: 33
    }, React.createElement(Botonera, {
      flotante: true,
      consolaLupa: 'no',
      consolaAudio: false,
      textoTrack: '',
      botones: [],
      onCerrar: caducado ? false : onCerrar,
      onBoton: false,
      onZoomMas: false,
      onZoomInicial: false,
      onZoomMenos: false
    }), React.createElement(ContenidoVentana, null, React.createElement('div', {
      className: 'centradoAbsoluto',
      style: {
        width: '90%',
        fontSize: '1.5em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        webkitTransform: 'translate(-50%, -50%)',
        transform: 'translate(-50%, -50%)'
      },
      dangerouslySetInnerHTML: {
        __html: msg
      }
    }))));
  };

  return Ventana;
}(React.Component);

Ventana.propTypes = process.env.NODE_ENV !== "production" ? {
  caducado: t.bool.isRequired,
  msg: t.string,
  // onKs: t.func,
  onCerrar: t.func
} : {};
export default Ventana;